Handlebars.getTemplate = function(name) {
	if (Handlebars.templates === undefined || Handlebars.templates[name] === undefined) {
		$.ajax({
			url : Handlebars.getViewUrl(name),
			dataType: 'text',
			cache:false,
			success : function(data) {
				if (Handlebars.templates === undefined) {
					Handlebars.templates = {};
				}
				Handlebars.templates[name] = Handlebars.compile(data);
			},
			async : false
		});
	}

	return Handlebars.templates[name];
};

Handlebars.getPartial = function(name) {
	if (Handlebars.partials === undefined || Handlebars.partials[name] === undefined) {
		$.ajax({
			url : Handlebars.getViewUrl(name),
			dataType: 'text',
			cache:false,
			success : function(data) {
				if (Handlebars.partials === undefined) {
					Handlebars.partials = {};
				}
				Handlebars.partials[name] = data;
			},
			async : false
		});
	}

	return Handlebars.partials[name];
};

Handlebars.getViewUrl = function(name){
	return ACC.config.commonResourcePath + '/views/' + name + ACC.config.handlebarjsExt;
};

Handlebars.registerHelper('ternary', function(test,yes,no) {
	return test?yes:no;
});

Handlebars.registerHelper("customPagination", function (pagination) {

    var dotsObj = {dots:true};
    var pages = pagination.pages;
    var output = [];
    var currentPage = parseInt(pagination['current-page'].replace(/,/g, ''));
    var pagesTotal = parseInt(pagination['page-total'].replace(/,/g, ''));

    /*console.log('Total Pages: ' + pagesTotal);
    console.log('Current Page: ' + currentPage);
    console.log('First Page: ' + pagination['first']);
    console.log('Last Page: ' + pagination['last']);*/

    if(pagesTotal<=5) {
        return pagination.pages;
    }

    if(pagination.first==='' || currentPage==2) {

        pages.forEach(function(page, index){
            if(index<=2) {
                output.push(page);
            }
        });

        output.push(dotsObj);

        //generate last
        output.push({
            page: pagesTotal,
            link: pagination['last']===''?'':pagination.last,
            selected: pagination['last']===''?true:false
        });

    } else if(pagination.last==='' || currentPage==pagesTotal-1) {
        //generate first
        output.push({
            page: 1,
            link: pagination['first']===''?'':pagination.first,
            selected: pagination['first']===''?true:false
        });
        output.push(dotsObj);

        pages.forEach(function(page, index){
            if(parseInt(page.page.replace(/,/g, ''))>=pagesTotal-2) {
                output.push(page);
            }
        });
    } else if(currentPage===3) {

        pages.forEach(function (page, index) {
            if (index <= 3) {
                output.push(page);
            }
        });
        output.push(dotsObj);

        //generate last
        output.push({
            page: pagesTotal,
            link: pagination['last'] === '' ? '' : pagination.last,
            selected: pagination['last'] === '' ? true : false
        });
    } else if(currentPage==pagesTotal-2) {

        // console.log('currentPage==pagesTotal-2');
        //generate first
        output.push({
            page: 1,
            link: pagination['first']===''?'':pagination.first,
            selected: pagination['first']===''?true:false
        });
        output.push(dotsObj);

        pages.forEach(function(page, index){
            // console.log(parseInt(page.page.replace(/,/g, '')));
            if(parseInt(page.page.replace(/,/g, ''))>=pagesTotal-3) {
                output.push(page);
            }
        });
    } else {
        /*console.log('else');
        console.log('Pages: ' + parseInt(currentPage-1) + ' - ' + parseInt(currentPage) + ' - ' + parseInt(currentPage+1));*/

        //generate first
        output.push({
            page: 1,
            link: pagination['first']===''?'':pagination.first,
            selected: pagination['first']===''?true:false
        });
        output.push(dotsObj);

        pages.forEach(function(page){
            if ($.inArray(parseInt(page.page.replace(/,/g, '')),[currentPage-1, currentPage, currentPage+1]) > -1) {
                output.push(page);
            }
        });

        output.push(dotsObj);

        //generate last
        output.push({
            page: pagesTotal,
            link: pagination['last']===''?'':pagination.last,
            selected: pagination['last']===''?true:false
        });
    }

    return output;
});

Handlebars.registerHelper('areEquals', function(test1, test2) {
	return (test1==test2)?true:false;
});

Handlebars.registerHelper('areEqualsOr', function(test1, cond1, cond2) {
	return (test1==cond1 || test1==cond2)?true:false;
});


Handlebars.registerHelper('areEqualsCustom', function(test1, test2, yes, no) {
	return (test1==test2)?yes:no;
});

Handlebars.registerHelper('i18n', function(prop) {
	return SPAR.adobe.messages[prop];
});

Handlebars.registerHelper('lowerCase',function(str){
    if(str) {
	    return str.toLowerCase();
    } else {
        return '';
    }
});

Handlebars.registerHelper('xif', function(val1,cond,val2,options) {
	switch(cond) {
		case "==":
			return (val1 == val2)?options.fn(this):options.inverse(this);
		case "===":
			return (val1 === val2)?options.fn(this):options.inverse(this);
		case "!=":
			return (val1 != val2)?options.fn(this):options.inverse(this);
		case "!==":
			return (val1 !== val2)?options.fn(this):options.inverse(this);
		case ">":
			return (val1 > val2)?options.fn(this):options.inverse(this);
		case ">=":
			return (val1 >= val2)?options.fn(this):options.inverse(this);
		case "<":
			return (val1 < val2)?options.fn(this):options.inverse(this);
		case "<=":
			return (val1 <= val2)?options.fn(this):options.inverse(this);
		case "&&":
			return (val1 && val2)?options.fn(this):options.inverse(this);
		case "||":
			return (val1 || val2)?options.fn(this):options.inverse(this);
		case "%":
			return (val1 % val2 === 0)?options.fn(this):options.inverse(this);
		case "!%":
			return (val1 % val2 === 1)?options.fn(this):options.inverse(this);
		default:
			return options.inverse(this);
	}
});

Handlebars.registerHelper('ifCondCustom', function(val1,cond,val2,yes,no) {
	switch(cond) {
		case "==":
			return (val1 == val2)?yes:no;
		case "===":
			return (val1 === val2)?yes:no;
		case "!=":
			return (val1 != val2)?yes:no;
		case "!==":
			return (val1 !== val2)?yes:no;
		case ">":
			return (val1 > val2)?yes:no;
		case ">=":
			return (val1 >= val2)?yes:no;
		case "<":
			return (val1 < val2)?yes:no;
		case "<=":
			return (val1 <= val2)?yes:no;
		case "&&":
			return (val1 && val2)?yes:no;
		case "||":
			return (val1 || val2)?yes:no;
		default:
			return no;
	}
});

Handlebars.registerHelper('checkAllIfEmpty', function(toCheck1, toCheck2) {
	return toCheck1 === '' && toCheck2 === '';
});

Handlebars.registerHelper('allEmpty', function() {
	var arrayToCheck = _.dropRight(arguments);
	var options = _.last(arguments);
	return (!_.every(arrayToCheck, String)?options.fn(this):options.inverse(this));
});

Handlebars.registerHelper('howManyPromo', function(promos,separator) {
	if(promos==="" || promos === undefined){
		return "";
	}

	var promoArray = promos.split(separator);
	if(promoArray.length === 1){
		return "product--single";
	} else if(promoArray.length === 2){
		return "product--double";
	} else {
		return "";
	}
});

Handlebars.registerHelper("repeat", function (times, opts) {
	var out = "";
	var i;
	var data = {};

	if ( times ) {
		for ( i = 0; i < times; i += 1 ) {
			data.index = i;
			data.count = i+1;
			out += opts.fn(this, {
				data: data
			});
		}
	} else {
		out = opts.inverse(this);
	}
	return out;
});

Handlebars.registerHelper('math', function(val1,op,val2) {
	switch(op) {
		case "+":
			return (val1 + val2);
		case "-":
			return (val1 - val2);
		case "*":
			return (val1 * val2);
		case "/":
			return (val1 / val2);
		default:
			return val1;
	}
});

Handlebars.registerHelper('paginationMath', function(val1,val2) {
    var total = (parseInt(val1.replace(/,/g, ''))-parseInt(val2.replace(/,/g, '')))+1;
    return total;
});

Handlebars.registerHelper('sizeOf', function(array) {
	if(array) {
		return array.length;
	}
	return 0;
});

Handlebars.registerHelper('getElementByIndex', function(test,separator,index) {
    if(test === undefined) {
        return "";
    }
	var splitted = test.toString().split(separator);
	return splitted[index];
});

Handlebars.registerHelper('getArrayElementByIndex', function(array,index) {
	return array[index];
});

Handlebars.registerHelper('stringToArray', function(test,separator) {
	var out = [];
	if(test!=="") {
		out = test.split(separator);
	}
	return out;
});

Handlebars.registerHelper('isFavorite', function(favoriteProducts,separator,productCode) {
	if (!productCode) {
		return false;
	}

	var splittedArray = favoriteProducts.split(separator);
	return ACC.common.contains(splittedArray,productCode);
});

Handlebars.registerHelper('stringLength', function(string) {
    if(string === undefined) {
        return 0;
    }
	return string.length;
});

Handlebars.registerHelper('isOnSale', function(bestPrice,actualPrice,regularPrice) {
	var out = "";
	if(actualPrice || (bestPrice && bestPrice!==regularPrice) ) {
		out = "sales";
	}
	return out;
});

Handlebars.registerHelper('getInsteadOfPrice', function(bestPrice,actualPrice,regularPrice) {
	if(bestPrice && bestPrice!==actualPrice && bestPrice!==regularPrice){
		return (actualPrice?actualPrice:regularPrice);
	}
	return (actualPrice?regularPrice:"&nbsp;");
});

Handlebars.registerHelper('getMainPrice', function(bestPrice,actualPrice,regularPrice) {
	if(bestPrice && bestPrice!==actualPrice && bestPrice!==regularPrice){
		return bestPrice;
	}
	return (actualPrice?actualPrice:regularPrice);
});

Handlebars.registerHelper('getSavings', function(bestPrice,actualPrice,regularPrice) {

	var mainPrice = Handlebars.helpers.getMainPrice(bestPrice,actualPrice,regularPrice);
	var insteadOfPrice = Handlebars.helpers.getInsteadOfPrice(bestPrice,actualPrice,regularPrice);

	if(insteadOfPrice==="&nbsp;")
		return "&nbsp;";

	mainPrice = parseFloat(mainPrice.replace(/,/g, "."));
	insteadOfPrice = parseFloat(insteadOfPrice.replace(/,/g, "."));

	var savings = parseInt(((insteadOfPrice-mainPrice)/insteadOfPrice)*100,10);

	return  Handlebars.helpers.i18n('basket.product.saving.price.lbl') + " " + savings + "%";
});

Handlebars.registerHelper('isSaving', function(absoluteSaving) {

	if (parseFloat(absoluteSaving.replace(/,/g, ".")) > 0.00){
		return true;
	}

	return false;
});

Handlebars.registerHelper('sparPrice', function(price,type) {
	if(price===undefined || price===null || price===""){
		return "00";
	}

	var priceSplitted = price.split('.');
	if("integer"===type){
		return priceSplitted[0];
	}

	//###decimal case

	//no decimal? return 00
	if(priceSplitted.length<2){
		return "00";
	}

	//decimal length = 1, concat a 0 at the end
	if(priceSplitted[1].length==1){
		return priceSplitted[1] + "0";
	}

	//decimal length > 1, return 2 decimal
	return priceSplitted[1].substring(0,2);
});

Handlebars.registerHelper('isRatingsAvailable', function(ratings,options) {
	var facetValues = ratings.facetvalues;
	var isRatingAvailable = (ratings && facetValues && facetValues.length === 1 && facetValues[0].value==0)?false:true;
	return isRatingAvailable?options.fn(this):options.inverse(this);
});

Handlebars.registerHelper('isPricesAvailable', function(priceRange,options) {
	var isPricesAvailable = (!_.isEmpty(priceRange) && parseFloat(priceRange.max)>0);
	return isPricesAvailable?options.fn(this):options.inverse(this);
});

Handlebars.registerHelper('isNotAvailable', function(product,options) {
	var isNotAvailable = (product['product-stock-status']=='outOfStock' || product.hasPrice=='false') ;
	return isNotAvailable?options.fn(this):options.inverse(this);
});

Handlebars.registerHelper('formatNumber', function(number) {
	parseInt(number, 10).toLocaleString(ACC.config.currentLanguage)
	return (number);
});

Handlebars.registerHelper('replaceCommaWithDot', function(number) {
	return number.replace(",",".");
});

Handlebars.registerHelper('removeWhitespace', function(string) {
	return string.replaceAll(" ","");
});

Handlebars.registerHelper('getBadgeTitle', function(badgeName) {
    var badgeString = "";

    if(badgeName === undefined) {
        return badgeString;
    }

    if (badgeName === "5% Aktionsrabatt") {
        badgeString = Handlebars.helpers.i18n('badge.stepped.title');
    }
    else if (badgeName === "Ab-Hof-Preis") {
        badgeString = Handlebars.helpers.i18n('badge.abhof.pdp.iconlabel');
    }
	else if (badgeName.toLowerCase() === 'bio' || badgeName.toLowerCase() === 'bio-dynamisch' || badgeName.toLowerCase() === 'demeter') {
		badgeString = badgeName;
	}
    else {
        badgeString = Handlebars.helpers.i18n('product.tooltip');
    }
    return badgeString;
});

Handlebars.registerHelper('getFacetValue', function(facetName, facetValue) {
	var facetValueMapped = '';

	if (facetName === '' || facetName === undefined) {
		return facetValue;
	}
	
	if (facetName.toLowerCase() === 'ex-farm' || facetName.toLowerCase() === 'ecr-vegan' || facetName.toLowerCase() === 'fairtrade-facet') {
		facetValueMapped = Handlebars.helpers.i18n('search.nav.facet.'+facetName.toLowerCase()+'.'+facetValue.toLowerCase());
	}

	if (facetValueMapped === undefined || facetValueMapped === ''){
		return facetValue;
	}

	return facetValueMapped;
});

Handlebars.registerHelper('clearAllQuery', function(queryURL, categoryURL) {
	var saleFilter = ACC.config.isSalesPage ? encodeURI('&filter=badge-short-name:Sale') : '';
	return '?query=' + queryURL + '&q=' + queryURL + '&page=1&hitsPerPage=' + SPAR.adobe.hitsPerPage + (categoryURL ? '&filter=' + encodeURI('category-path:' + categoryURL) : '') + saleFilter;
});

Handlebars.partials = Handlebars.templates; //very important, it takes all partials and put it in the Handlebars.partials object
